// extracted by mini-css-extract-plugin
export default {"root":"PageInfo_root__Xe2j+","desc":"PageInfo_desc__Yo7wr"};